import { extractCookie } from 'lib/web/cookieUtils'

export const recentlyViewedMerchandiseCookieKey = 'recentlyViewedMerchandise'

function getRecentlyViewedMerchandise(): Promise<Array<string>> {
  const cookieValue = extractCookie(document.cookie, recentlyViewedMerchandiseCookieKey) ?? ''
  const merchandiseIds = cookieValue.split(',').filter(Boolean)
  return Promise.resolve(merchandiseIds)
}

export default getRecentlyViewedMerchandise
